module.exports = __webpack_public_path__ + "static/media/betyaros_background_green.d7908d43.jpg";